import {
  switchMap,
  map,
  filter,
  take,
  shareReplay,
  withLatestFrom,
  ignoreElements,
  tap,
} from 'rxjs/operators';
import { combineEpics, ofType } from 'redux-observable';
import playerActions from 'tg-core-redux/lib/modules/player/action';
import { handleRequiredActions } from '@utils/player';
import selectRequiredActions from '@selectors/selectRequiredActions';

const handleActions = (action$, state$) =>
  action$.pipe(
    ofType(
      'SIGNIN_PNP_COMPLETE',
      'SIGNINV2_COMPLETE',
      'SIGNINWITHCODE_COMPLETE',
      'SIGNINV2_FAILURE',
      'SIGNINWITHCODE_FAILURE',
      'GET_DISPLAY_PAGES_COMPLETE'
    ),
    filter(
      () =>
        state$.value.player.isLoading !== true &&
        state$.value.content.sets.isLoading !== true
    ),
    filter(() => selectRequiredActions(state$.value).length > 0),
    tap(() => {
      handleRequiredActions(state$.value);
    }),
    ignoreElements()
  );

const getDisplayPagesAfterRequiredAction = (action$, state$) =>
  action$.pipe(
    ofType(
      'SOURCE_OF_WEALTH_COMPLETE',
      'RG_PGSI_COMPLETE',
      'REQUEST_SET_DEPOSIT_LIMITS_COMPLETE',
      'UPDATE_PLAYER_TAC_COMPLETE',
      'REQUEST_UPDATE_PLAYER_INFO_COMPLETE'
    ),
    map(() => playerActions.getDisplayPages(state$.value.player.sessionId))
  );

export default combineEpics(getDisplayPagesAfterRequiredAction, handleActions);
